<div class="object-orientation tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.object-orientation' | translate }}
    </h5>
    <div class="object-orientation-list tool-list">
        <div
            class="content-wrapper"
            *ngFor="let orientationTool of OBJECT_ORIENTATION_TOOL_LIST; index as i; let isLast = last"
            [matTooltip]="orientationTool.tooltip | translate"
            (click)="moveElement(orientationTool)">
            <mat-icon class="icon icon-objectOrientation" [svgIcon]="orientationTool.svgIcon"></mat-icon>
            <p class="orientation-tool-text">
                {{ TRANSLATE_PREFIX.concat('.', orientationTool.name) | translate }}
            </p>
        </div>
    </div>
</div>
